import { memo } from "react";
import { useSelector } from "react-redux";

import {
  Accessibility,
  Elevator,
  ElevatorBroken,
  ElevatorGray,
  ElevatorYellow,
} from "./icons";

import "./StationIconsLegend.scss";

function StationIconsLegend() {
  const config = useSelector((state) => state.config?.stationIcons);
  const isDisplay = useSelector((state) => state.config?.stationIconsLegend);

  if (!isDisplay) {
    return null;
  }

  return (
    <div className="station-icons-legend">
      {config.hasElevator &&
        (config.hasElevatorOutOfOrder || config.hasElevatorState) && (
          <>
            <div>
              <Elevator
                className="trl-popup-station-icon"
                data-testid="elevator-icon"
              />
              <span className="trl-popup-station-label">
                Alle Aufzüge in Betrieb
              </span>
            </div>
            <div>
              <ElevatorBroken
                className="trl-popup-station-icon"
                data-testid="elevator-broken-icon"
              />
              <span className="trl-popup-station-label">
                Mindestens ein Aufzug außer Betrieb
              </span>
            </div>
          </>
        )}
      {config.hasElevator && config.hasElevatorState && (
        <>
          <div>
            <ElevatorYellow
              className="trl-popup-station-icon"
              data-testid="elevator-yellow-icon"
            />
            <span className="trl-popup-station-label">
              Mindestens ein Aufzug außer Betrieb
            </span>
          </div>
          <div>
            <ElevatorGray
              className="trl-popup-station-icon"
              data-testid="elevator-gray-icon"
            />
            <span className="trl-popup-station-label">
              Kein Aufzugstatus bekannt
            </span>
          </div>
        </>
      )}
      {config.hasAccessibility && (
        <div>
          <Accessibility
            className="trl-popup-station-icon"
            data-testid="accessibility-icon"
          />
          <span className="trl-popup-station-label">
            Barrierefreier Bahnhof, Aufzugstatus beachten
          </span>
        </div>
      )}
    </div>
  );
}

export default memo(StationIconsLegend);
